import { TSharedBetSlipResponse } from "@api-types/quick-play/SharedBetSlipDto";
import { Lookup } from "@data-types";
import {
	UserTypes,
	getAgencyKey,
	getApplicationHeaders,
	httpClient,
} from "@utils";

export default class SharedBetSlipsApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}${getAgencyKey()}/bet-slip-shares`;
	}

	static getRequestHeaders = (
		userType: UserTypes = UserTypes.PRIMARY,
		shouldUseToken = false
	) => {
		const appHeaders = getApplicationHeaders(userType, shouldUseToken);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async fetchAllSharedBetSlips(): Promise<
		Lookup<TSharedBetSlipResponse>
	> {
		return await httpClient.get(
			`${this.baseUrl}/fetch-all/?rpp=50&page=1&translate=true`,
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}

	static async insertSharedBetSlip(
		betSlipId: string,
		betSlipShareType: number,
		bettingAccountTypeId: string
	): Promise<void> {
		const userType: UserTypes =
			App.state.rootStore.userAuthStore.getWalletOwner(
				bettingAccountTypeId
			);
		const url = `${WEBPACK_BASE_ADDRESS}${getAgencyKey(
			userType
		)}/bet-slip-shares/insert/${betSlipId}?betSlipSharedType=${betSlipShareType}`;

		return await httpClient.get(url, this.getRequestHeaders(userType), {
			responseType: "json",
		});
	}
}
